import { render, staticRenderFns } from "./SolanJournalsTTableHeaderRow.vue?vue&type=template&id=3032b560&scoped=true&"
import script from "./SolanJournalsTTableHeaderRow.vue?vue&type=script&lang=ts&"
export * from "./SolanJournalsTTableHeaderRow.vue?vue&type=script&lang=ts&"
import style0 from "./SolanJournalsTTableHeaderRow.vue?vue&type=style&index=0&id=3032b560&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3032b560",
  null
  
)

export default component.exports